import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import request from 'axios';

const Form = ({
  submit_label, action_url, security_code, promo, className, align, callback, background,
  showSingleNameField=false, hideNameFields=false, notice, formTitle, fullWidth
}) => {
  const style = (!background || ["gray", "white"].includes(background))? undefined : { background };

  return (
    <div className={classnames('block block-email-subs-form', className, background)} style={style}>
      <div className={classnames("row", align)}>
        <div className={classnames("columns small-16", { "medium-12 large-6": !fullWidth })}>
          { !!formTitle && <h3 className="form-title">{ formTitle }</h3> }

          <form action={action_url} method="post">
            <div className="form-group">
              <input type="email" name="EMAIL" className="form-control" id="mce-EMAIL"/>
              <label htmlFor="mce-EMAIL" className="form-label animate">
                Email Address
              </label>
            </div>

            { !hideNameFields &&
            <div className="form-group">
              <input type="text" name="FNAME" className="form-control" id="mce-FNAME"/>
              <label htmlFor="mce-FNAME" className="form-label animate">First Name</label>
            </div> }

            { !showSingleNameField && !hideNameFields &&
            <div className="form-group">
              <input type="text" name="LNAME" className="form-control" id="mce-LNAME"/>
              <label htmlFor="mce-LNAME" className="form-label animate">Last Name </label>
            </div> }

            {/* real people should not fill this in and expect good things - do not remove this or
                risk form bot signups */}
            <div style={{position: "absolute", left: "-5000px"}} aria-hidden={true}>
              <input type="text" name={security_code} tabIndex="-1" value=""/>
            </div>

            <input type="submit" value={submit_label} onClick={callback} className="btn btn-tertiary"/>
            <p className="notice"
              dangerouslySetInnerHTML={{ __html: notice || "100% privacy guaranteed" }}></p>
          </form>
          { !!promo && <h4 className="promo">{ promo }</h4> }
        </div>
      </div>
    </div>
  );
}

Form.propTypes = {
  submit_label: PropTypes.string,
  action_url: PropTypes.string,
  security_code: PropTypes.string,
  promo: PropTypes.string,
  className: PropTypes.string,
  align: PropTypes.string,
  background: PropTypes.string,
  notice: PropTypes.string,
  showSingleNameField: PropTypes.bool,
  hideNameFields: PropTypes.bool,
  formTitle: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default Form;
